import React from 'react';
import { Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { useEditFormContext } from '../context';
import { useDragNDrop } from 'components/DragContainer/hook/useDragNDrop';
import { QuestionDragCard } from './QuestionDragCard';
import { IQuestionItem } from '../types';
import { EditQuestionModal } from '../EditQuestionModal';

export const CreatedQuestionsContainer = () => {
  const styles = useStyles();
  const { questionList, setQuestionList } = useEditFormContext();

  const { handleDrop, handleLeave, handleOver, handleStart } = useDragNDrop({
    data: questionList,
    onChangeOrder: setQuestionList
  });

  const handleUpdateQuestion = (questionData: IQuestionItem) => {
    setQuestionList((prev) => {
      const itemIndex = prev.findIndex((item) => item.id === questionData.id);
      if (itemIndex < 0) return [...prev, questionData];

      prev[itemIndex] = questionData;
      return [...prev];
    });
  };

  const handleDeleteQuestion = (id: number) => {
    setQuestionList((prev) => prev.filter((question) => question.id !== id));
  };

  return (
    <div>
      <Typography className={styles.title}>Questões Criadas:</Typography>
      <EditQuestionModal onUpdateQuestion={handleUpdateQuestion} />
      <div className={styles.dragContainer}>
        {questionList.length === 0 && <Typography> Nenhuma questão criada</Typography>}
        {questionList.map((item, index) => (
          <QuestionDragCard
            item={item}
            pos={index + 1}
            handleLeave={handleLeave}
            handleOver={handleOver}
            handleStart={handleStart}
            handleDrop={handleDrop}
            key={item.id}
            onDeleteQuestion={handleDeleteQuestion}
          />
        ))}
      </div>
    </div>
  );
};
